import React, { useCallback } from "react";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import ReactPlayer from "react-player";
import { call } from "services/axiosService/core";
import { useMaterialUIController } from "context";
import Refresh from "pages/refresh/Refresh";
import * as Sentry from "@sentry/browser";
import { useTranslation } from "react-i18next";
import ContentPlayerDialog from "examples/Dialog/ContentPlayerDialog";

const PlayContent = () => {
  const { t } = useTranslation();
  const [controller] = useMaterialUIController();
  const { profile } = controller;
  const { contentTitle } = useParams();
  const [playContent, setPlayContent] = useState(false);
  const [metrics, setMetrics] = useState(false);
  const [content, setContent] = useState({});
  const [userMetricsData, setUserMetricsData] = useState({});
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    loadUserContentMetrics();
  }, [profile]);

  useEffect(() => {
    getContentLinkHandler();
  }, [profile]);

  const loadUserContentMetrics = () => {
    call(`users/${profile.id}/contentmetrics`, "GET", {})
      .then((res) => {
        if (res.status == 200) {
          let data = res.data;
          setUserMetricsData(data);
          setMetrics(true);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const getContentLinkHandler = () => {
    call(`content/${contentTitle}`, "GET", {})
      .then((res) => {
        if (res.status == 200) {
          setPlayContent(true);
          setContent(res.data);
        } else if (res.status == 440) {
          setSessionExpired(true);
        }
      })
      .catch((err) => {
        console.log("error is", err);
        Sentry.captureException(err);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title={contentTitle} />

      {playContent && metrics && (
        <ContentPlayerDialog
          playContent={playContent}
          content={content}
          userMetricsData={userMetricsData}
          setUserMetricData={setUserMetricsData}
          userId={profile.id}
          setSessionExpired={setSessionExpired}
          t={t}
        />
      )}
      {sessionExpired && <Refresh />}
    </DashboardLayout>
  );
};

export default PlayContent;
